import { FormattedMessage, useIntl } from 'react-intl'

import ModalFooterActionContainer from '../TripModal/TripItems/Create/ModalFooterActionContainer'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'

interface Props {
  updateTripDates: () => void
  currentTripDates: string
  extendedTripDates: string
  isLoading: boolean
}

function ConfirmUpdateTripDatesModal(props: Props) {
  const { updateTripDates, isLoading, currentTripDates, extendedTripDates } =
    props

  const intl = useIntl()
  const { closeModal, goBack } = useModalCallbacks()
  const isMobile = useScreenSizeOnly('mobile')

  return (
    <>
      <ModalHeader
        title={intl.formatMessage({
          id: 'OnfQv-IBgdWE8Y5DKmkz',
          defaultMessage: 'Extend trip duration',
          description: 'Modal title for confirming trip date extension in the trip planner itinerary view',
        })}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={12}>
            <BodyTextBlock variant="large">
              {intl.formatMessage({
                id: 'yuP-ph2MQVRl3fkEa_fz',
                defaultMessage: 'Please check the new dates for your trip',
                description: 'Instruction asking user to review the proposed new trip dates',
              })}
            </BodyTextBlock>
            <div>
              <BodyTextBlock variant="large">
                <FormattedMessage
                  id="yBV1Nz-IQI0bosOFhyGD"
                  defaultMessage="<bold>Current trip dates:</bold> {currentTripDates}"
                  description="Current trip date range with bold label in the trip planner feature"
                  values={{
                    bold: (chunks) => <b>{chunks}</b>,
                    currentTripDates,
                  }}
                />
              </BodyTextBlock>
              <BodyTextBlock variant="large">
                <FormattedMessage
                  id="Y_S916tVjPjrSH8AO692"
                  defaultMessage="<bold>New trip dates:</bold> {extendedTripDates}"
                  description="Proposed new trip date range with bold label in the trip planner"
                  values={{
                    bold: (chunks) => <b>{chunks}</b>,
                    extendedTripDates,
                  }}
                />
              </BodyTextBlock>
            </div>
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <ModalFooterActionContainer>
          <TextButton
            kind="secondary"
            size="large"
            fit={`${isMobile ? 'full-width' : 'auto'}`}
            onClick={closeModal}
          >
            {intl.formatMessage({
              id: '5BCuAAjU-XiFOrPdkX_V',
              defaultMessage: 'Cancel',
              description: 'Button to cancel and close the trip date extension modal',
            })}
          </TextButton>
          <TextButton
            kind="primary"
            size="large"
            fit={`${isMobile ? 'full-width' : 'auto'}`}
            onClick={updateTripDates}
            disabled={isLoading}
          >
            {intl.formatMessage({
              id: '0WWj9AhCf6PV8QL8aVab',
              defaultMessage: 'Confirm new trip dates',
              description: 'Button to confirm and save the extended trip dates',
            })}
          </TextButton>
        </ModalFooterActionContainer>
      </ModalFooter>
    </>
  )
}

export default ConfirmUpdateTripDatesModal
